import React from 'react'

import styles from './HeroBanner.module.scss'
import HeroBannerContent from './heroBannerContent/HeroBannerContent'
import BackgroundTitle from '../common/backgroundTitle/BackgroundTitle'

const backgroundTitle = 'Innovation'

const HeroBanner = () => {
  return (
    <div
      style={{ background: 'linear-gradient(180deg, #012111 0%, #00531C 100%)' }}
      className="flex flex-col h-full items-center overflow-y-auto overflow-x-hidden"
    >
      <div className={styles.containerTop}>
        <div className="bg-transparent">
          <BackgroundTitle title={backgroundTitle} initialFontSize="200px" strokeColor="#006B3F" />
        </div>
      </div>
      <HeroBannerContent />
      <div
        style={{ background: 'linear-gradient(180deg, #012111 0%, #00531C 100%)' }}
        className="flex-1 w-[150%] px-[25%] mt-64"
      >
        <svg
          width="100%"
          height="400"
          viewBox="0 0 100 100"
          stroke="#fff"
          preserveAspectRatio="none"
          className="-mt-[400px]"
        >
          <path d="M0,100 Q50,0 100,100 Z" fill="#FFFFFF" />
        </svg>
      </div>
    </div>
  )
}

export default HeroBanner
